"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchEmbedDashboardPack = exports.fetchTemplateDashboardPack = exports.fetchShareDashboardPack = exports.fetchDashboardPack = void 0;
const axios_1 = __importDefault(require("axios"));
const urlcat_1 = __importDefault(require("urlcat"));
const Url = __importStar(require("./url.data"));
const baseURL = process.env.NEXT_PUBLIC_NEXT_API;
const fetchDashboardPack = (dashboardId) => {
    return axios_1.default.get((0, urlcat_1.default)(Url.FETCH_DASHBOARD, { dashboardId }), {
        baseURL,
    });
};
exports.fetchDashboardPack = fetchDashboardPack;
const fetchShareDashboardPack = (dashboardId, shareId) => {
    return axios_1.default.get((0, urlcat_1.default)(Url.FETCH_SHARE_DASHBOARD, { shareId, dashboardId }), {
        baseURL,
    });
};
exports.fetchShareDashboardPack = fetchShareDashboardPack;
const fetchTemplateDashboardPack = (dashboardId, templateId) => {
    return axios_1.default.get((0, urlcat_1.default)(Url.FETCH_TEMPLATE_DASHBOARD, { dashboardId, templateId }), {
        baseURL,
    });
};
exports.fetchTemplateDashboardPack = fetchTemplateDashboardPack;
const fetchEmbedDashboardPack = (dashboardId, embedId) => {
    return axios_1.default.get((0, urlcat_1.default)(Url.FETCH_EMBED_DASHBOARD, { dashboardId, embedId }), {
        baseURL,
    });
};
exports.fetchEmbedDashboardPack = fetchEmbedDashboardPack;
//# sourceMappingURL=dashboard_api.js.map